import IconPicker from "./IconPicker";

export default IconPicker;
